<label class="ac-checkbox-label" [class.checkbox-sides-margin]="sideMargin">
    <mat-checkbox *ngIf="!labelOnly else label"
                  class="ac-checkbox"
                  [ngModel]="model"
                  [attr.value]="model"
                  color="primary"
                  (ngModelChange)="checkboxValueChanged($event)"
                  [(indeterminate)]="indeterminate"
                  [id]="checkboxId"
                  [labelPosition]="labelPosition"
                  [disabled]="(ngDisabled || (acInputContainer && acInputContainer.isDisabled))?true:null">
        <ng-container [ngTemplateOutlet]="label"></ng-container>
        <ng-content></ng-content>
    </mat-checkbox>
</label>

<ng-template #label>
    <span *ngIf="labelText" class="ac-checkbox-label-text">{{labelText}}</span>
</ng-template>
